import { render, staticRenderFns } from "./ManagerStatistics.vue?vue&type=template&id=51a62a36&scoped=true&"
import script from "./ManagerStatistics.vue?vue&type=script&lang=js&"
export * from "./ManagerStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a62a36",
  null
  
)

export default component.exports